import { reactive, ref } from "vue";

export const SYNC_STEPS = Object.freeze({
  WAITING: "waiting",
  SENDING: "sending",
  SENT: "sent",
  BLOCKED: "blocked",
});

export const syncRun = reactive({ running: false, steps: {} });

export const isSyncDialogOpen = ref(false);

export const openSyncDialog = () => {
  isSyncDialogOpen.value = true;
};

export const startSyncRun = (keys) => {
  syncRun.steps = Object.fromEntries(
    keys.map((key) => [key, SYNC_STEPS.WAITING])
  );
  syncRun.running = true;
};

export const endSyncRun = () => {
  syncRun.running = false;
};

export const markStep = (key, step) => {
  if (key in syncRun.steps) syncRun.steps[key] = step;
};
